/**
 * Pretty print name/value pairs in console
 */
export const prettyLog = (messages) => {
  const allLabels = messages.reduce((acc, val, ind) => {
    acc.push(val.label);
    return acc;
  }, []);

  const allOutput = messages.reduce((acc, val, ind) => {
    return [...acc, ...val.output];
  }, []);

  const limits = _getMaxLength(allOutput); // get longest string values
  limits.labelMax = _getMaxLabelLength(allLabels);

  for (const msg of messages) {
    msg.limits = limits;
    _prettyLog(msg);
  }
};

const _prettyLog = ({ label, output, limits }) => {
  /**
   * console formatting via css
   *    font-family: monospace;
   src: local('Menlo');
   */

  const font = 'font-family: monospace; src: local("Menlo");';
  const lbl = font + 'background-color:red; font-weight: bold; padding:3px 10px; color:white';
  const tpl1 = font + 'background-color:gainsboro; padding:3px 6px 3px 12px; color:black';
  const tpl2 = font + 'background-color:palegreen; font-weight: bold; padding:3px 6px; color:black';
  const template = [tpl1, tpl2];

  const maxLength = limits || _getMaxLength(output);
  const labelPadded = _rightPad(label, limits.labelMax);
  const f = `%c${labelPadded}` + _formatLog(output, maxLength);
  /**
   * Generate message formatting
   */
  const css = output.reduce((acc, val, ind) => {
    return [...acc, ...template];
  }, []);
  console.info(f, lbl, ...css);
};

/**
 * calc max length for all keys and all values
 */
const _getMaxLabelLength = (ary) => {
  return ary.reduce((acc, val, ind) => {
    acc = Math.max(acc, val.toString().length);
    return acc;
  }, 0);
};

const _getMaxLength = (ary) => {
  return ary.reduce(
    (acc, val, ind) => {
      acc.key = Math.max(acc.key, val.key.toString().length);
      acc.val = Math.max(acc.val, val.val.toString().length);
      return acc;
    },
    { key: 0, val: 0 }
  );
};

/**
 * Pad and format each name/value pair
 */
const _formatLog = (ary, maxLength) => {
  return ary.reduce((acc, val, ind) => {
    const key = _leftPad(val.key, maxLength.key);
    const value = _rightPad(val.val, maxLength.val);
    acc += `%c${key}%c${value}`;
    return acc;
  }, '');
};

const _leftPad = (str, length = 10) => {
  return `${' '.repeat(Math.max(length - str.toString().length, 0))}${str}`;
};

const _rightPad = (str, length = 10) => {
  return `${str}${' '.repeat(Math.max(length - str.toString().length, 0))}`;
};
